export type ServiceType = 'main' | 'sections' | 'langschool'

export interface ServiceInfo {
  key: ServiceType
  label: string
}

export const SERVICE_MAP: Record<ServiceType, ServiceInfo> = {
  main: { key: 'main', label: 'Backend' },
  sections: { key: 'sections', label: 'be-sections' },
  langschool: { key: 'langschool', label: 'be-langschool' },
}

export const SERVICES: ServiceInfo[] = Object.values(SERVICE_MAP)

export const SERVICE_STORAGE_KEY = 'admin:selected-service'
